import React, { Component } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Header from '../layout/Header';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const images = [
    'https://via.placeholder.com/600X750/444444.jpg',
    'https://via.placeholder.com/600X750/444444.jpg',
    'https://via.placeholder.com/600X750/444444.jpg',
    'https://via.placeholder.com/600X750/444444.jpg',
    'https://via.placeholder.com/600X750/444444.jpg',
    'https://via.placeholder.com/600X750/444444.jpg'
  ];

export class Project_style2 extends Component {
    constructor(props) {
        super(props);
     
        this.state = {
          photoIndex: 0,
          isOpen: false,
        };
      }
    render() {
        const { photoIndex, isOpen } = this.state;
        return (
            <div className="site-main">
                <Header />
                {/* page-title */}
                <div className="ttm-page-title-row">
                    <div className="container-xl">
                        <div className="row">
                            <div className="col-md-12"> 
                                <div className="title-box">
                                    <div className="page-title-heading">
                                        <h1 className="title">Project Style 2</h1>
                                    </div>{/* /.page-title-captions */}
                                    <div className="breadcrumb-wrapper">
                                    <span>
                                        <a title="Homepage" href={process.env.PUBLIC_URL + '/'} >&nbsp;&nbsp;Home</a>
                                    </span>
                                    <span className="ttm-bread-sep">&nbsp; : : &nbsp;</span>
                                    <span>Project Style 2</span>
                                    </div>  
                                </div>
                            </div>{/* /.col-md-12 */}  
                        </div>{/* /.row */}  
                    </div>{/* /.container */}                      
                </div>
                {/* page-title end*/}
                {isOpen && (
                  <Lightbox
                    mainSrc={images[photoIndex]}
                    nextSrc={images[(photoIndex + 1) % images.length]}
                    prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                    onCloseRequest={() => this.setState({ isOpen: false })}
                    onMovePrevRequest={() =>
                      this.setState({
                        photoIndex: (photoIndex + images.length - 1) % images.length,
                      })
                    }
                    onMoveNextRequest={() =>
                      this.setState({
                        photoIndex: (photoIndex + 1) % images.length,
                      })
                    }
                  />
                )}
                <div className="ttm-row clearfix">
                    <div className="container-xl">
                        <div className="row multi-columns-row">
                            <div class="col-lg-4 col-md-6 col-sm-12">
                                <div class="ttm-box-portfolio-style2">
                                    <div class="ttm-box-portfolio-style1-overlay">
                                        <div class="portfolio-style-thumnail">
                                            <img width="828" height="800" class="img-fluid" src="images/portfolio/pf-7-828x800.png" loading="lazy" alt="pf-img" /></div>
                                        <div class="portfolio-style-content">
                                        <div class="protfolio-style1-box-category">
                                            <a href="#" class="protfolio-style2-category-link">Campaign ,</a>
                                            <a href="#" class="protfolio-style2-category-link">Corporate</a>
                                        </div>
                                        <div class="protfolio-style1-title">
                                            <h3 class="protfolio-style2-title-h3">
                                            <a href={process.env.PUBLIC_URL + '/project_details'} class="protfolio-style2-title-h3-link">IT consultancy</a>
                                            </h3>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12">
                                <div class="ttm-box-portfolio-style2">
                                    <div class="ttm-box-portfolio-style1-overlay">
                                        <div class="portfolio-style-thumnail">
                                            <img width="828" height="800" class="img-fluid" src="images/portfolio/pf-8-828x800.jpg" loading="lazy" alt="pf-img" /></div>
                                        <div class="portfolio-style-content">
                                        <div class="protfolio-style1-box-category">
                                            <a href="#" class="protfolio-style2-category-link">Business ,</a>
                                            <a href="#" class="protfolio-style2-category-link">Workshop</a>
                                        </div>
                                        <div class="protfolio-style1-title">
                                            <h3 class="protfolio-style2-title-h3">
                                            <a href={process.env.PUBLIC_URL + '/project_details'} class="protfolio-style2-title-h3-link">Product design</a>
                                            </h3>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12">
                                <div class="ttm-box-portfolio-style2">
                                    <div class="ttm-box-portfolio-style1-overlay">
                                        <div class="portfolio-style-thumnail">
                                            <img width="828" height="800" class="img-fluid" src="images/portfolio/pf-9-828x800.jpg" loading="lazy" alt="pf-img" /></div>
                                        <div class="portfolio-style-content">
                                        <div class="protfolio-style1-box-category">
                                            <a href="#" class="protfolio-style2-category-link">Innovation ,</a>
                                            <a href="#" class="protfolio-style2-category-link">Technology</a>
                                        </div>
                                        <div class="protfolio-style1-title">
                                            <h3 class="protfolio-style2-title-h3">
                                            <a href={process.env.PUBLIC_URL + '/project_details'} class="protfolio-style2-title-h3-link">Cloud computing</a>
                                            </h3>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12">
                                <div class="ttm-box-portfolio-style2">
                                    <div class="ttm-box-portfolio-style1-overlay">
                                        <div class="portfolio-style-thumnail">
                                            <img width="828" height="800" class="img-fluid" src="images/portfolio/pf-10-828x800.jpg" loading="lazy" alt="pf-img" /></div>
                                        <div class="portfolio-style-content">
                                        <div class="protfolio-style1-box-category">
                                            <a href="#" class="protfolio-style2-category-link">Business ,</a>
                                            <a href="#" class="protfolio-style2-category-link">Campaign</a>
                                        </div>
                                        <div class="protfolio-style1-title">
                                            <h3 class="protfolio-style2-title-h3">
                                            <a href={process.env.PUBLIC_URL + '/project_details'} class="protfolio-style2-title-h3-link">Big data analytics</a>
                                            </h3>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12">
                                <div class="ttm-box-portfolio-style2">
                                    <div class="ttm-box-portfolio-style1-overlay">
                                        <div class="portfolio-style-thumnail">
                                            <img width="828" height="800" class="img-fluid" src="images/portfolio/pf-11-828x800.jpg" loading="lazy" alt="pf-img" /></div>
                                        <div class="portfolio-style-content">
                                        <div class="protfolio-style1-box-category">
                                            <a href="#" class="protfolio-style2-category-link">Campaign ,</a>
                                            <a href="#" class="protfolio-style2-category-link">Technology</a>
                                        </div>
                                        <div class="protfolio-style1-title">
                                            <h3 class="protfolio-style2-title-h3">
                                            <a href={process.env.PUBLIC_URL + '/project_details'} class="protfolio-style2-title-h3-link">IT management</a>
                                            </h3>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-12">
                                <div class="ttm-box-portfolio-style2">
                                    <div class="ttm-box-portfolio-style1-overlay">
                                        <div class="portfolio-style-thumnail">
                                            <img width="828" height="800" class="img-fluid" src="images/portfolio/pf-13-828x800.png" loading="lazy" alt="pf-img" /></div>
                                        <div class="portfolio-style-content">
                                            <div class="protfolio-style1-box-category">
                                                <a href="#" class="protfolio-style2-category-link">Corporate ,</a>
                                                <a href="#" class="protfolio-style2-category-link">Workshop</a>
                                            </div>
                                            <div class="protfolio-style1-title">
                                                <h3 class="protfolio-style2-title-h3">
                                                <a href={process.env.PUBLIC_URL + '/project_details'} class="protfolio-style2-title-h3-link">Cloud services</a>
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <section class="ttm-row zero-padding-section ttm-bg ttm-bgcolor-gradient clearfix">
                    <div class="container-fluid p-0">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="marquee-block overflow-hidden">
                                    <div class="marquee">
                                        <div class="marquee-content">
                                            <div class="marquee-text">Automation</div>
                                            <div class="marquee-text">Established</div>
                                            <div class="marquee-text">Intuitive</div>
                                            <div class="marquee-text">Digital Marketing</div>
                                            <div class="marquee-text">Intuitive</div>
                                            <div class="marquee-text">Established</div>
                                            <div class="marquee-text">Automation</div>
                                            <div class="marquee-text">Established</div>
                                            <div class="marquee-text">Intuitive</div>
                                            <div class="marquee-text">Digital Marketing</div>
                                            <div class="marquee-text">Intuitive</div>
                                            <div class="marquee-text">Established</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
            )
    }
}


export default Project_style2;